export default __webpack_public_path__ + "163e341a23e00c5550d338641b4e6720.png";